export enum PersonType {
  Chase = "Chase",
  Lien = "Lien",
  Taylor = "Taylor",
  Saskia = "Saskia",
  Kushla = "Kushla",
  Patrick = "Patrick",
}

export enum ItineraryType {
  Flight = "Flight",
  CheckIn = "CheckIn",
  CheckOut = "CheckOut",
  Drive = "Drive",
  Walk = "Walk",
  Bus = "Bus",
  Train = "Train",
  Activity = "Activity",
  Sleep = "Sleep",
  Food = "Food",
}

export interface Itinerary {
  title: string;
  type: ItineraryType;
  fixedStart?: number; // Will either be the start or the duration, starts is as 24hr time, e.g. 1430 for 2:30pm
  fixedDuration?: number; // Duration in minutes
  recommendedDuration?: number; // Duration in minutes
  attendees: PersonType[];
  day?: number;
  link?: string;
}

export const START_DAY = new Date(2024, 7, 29);

const ITINERARY: Itinerary[] = [
  {
    // TODO
    title: "Flight to Lisbon",
    type: ItineraryType.Flight,
    fixedStart: 1600,
    fixedDuration: 120,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "",
  },
  {
    // TODO
    title: "Taxi to Hotel",
    type: ItineraryType.Drive,
    fixedDuration: 30,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "",
  },
  {
    // TODO
    title: "Check In to Hotel",
    type: ItineraryType.CheckIn,
    fixedDuration: 30,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "",
  },
  {
    // TODO
    title: "Relax at Hotel",
    type: ItineraryType.Activity,
    recommendedDuration: 60,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "",
  },
  {
    // TODO
    title: "Walk to Restaurant",
    type: ItineraryType.Walk,
    fixedDuration: 15,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "",
  },
  {
    // TODO
    title: "Dinner at MEOW",
    type: ItineraryType.Food,
    fixedStart: 2100,
    recommendedDuration: 120,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "",
  },
  {
    // TODO
    title: "Walk to Hotel",
    type: ItineraryType.Walk,
    fixedDuration: 15,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "",
  },
  {
    title: "Sleep",
    type: ItineraryType.Sleep,
    recommendedDuration: 60 * 10,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "",
  },
  // TODO
  {
    title: "Breakfast at Hotel",
    type: ItineraryType.Food,
    fixedStart: 900,
    recommendedDuration: 90,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "",
  },
  {
    title: "MEOW (5 hours)",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 5,
    attendees: [PersonType.Chase, PersonType.Lien],
  },
  {
    title: "Taxi to festival",
    type: ItineraryType.Drive,
    fixedDuration: 30,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "https://maps.app.goo.gl/uE8A7yqejchAzXu78",
  },
  {
    title: "Lisboa Festival",
    type: ItineraryType.Activity,
    fixedStart: 1600,
    fixedDuration: 8 * 60,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "https://meokalorama.pt/en",
  },
  {
    title: "Flight to Lisbon",
    type: ItineraryType.Flight,
    fixedStart: 1510,
    fixedDuration: 2 * 60 + 50,
    attendees: [PersonType.Kushla, PersonType.Saskia, PersonType.Taylor],
  },
  {
    title: "Rent Car",
    type: ItineraryType.Drive,
    fixedDuration: 45,
    attendees: [PersonType.Kushla, PersonType.Saskia, PersonType.Taylor],
  },
  {
    title: "Travel to Cascais",
    type: ItineraryType.Bus,
    fixedStart: 1845,
    fixedDuration: 120,
    attendees: [PersonType.Kushla, PersonType.Saskia, PersonType.Taylor],
    link: "https://maps.app.goo.gl/1rT7sb7zG3VqcYcv5",
  },
  {
    title: "Check into Cascias Hotel",
    type: ItineraryType.CheckIn,
    fixedStart: 2045,
    fixedDuration: 30,
    attendees: [PersonType.Kushla, PersonType.Saskia, PersonType.Taylor],
    link: "https://www.vilabicuda.com/en/",
  },
  {
    title: "Rest at hotel",
    type: ItineraryType.Activity,
    recommendedDuration: 30,
    attendees: [PersonType.Kushla, PersonType.Saskia, PersonType.Taylor],
    link: "https://www.vilabicuda.com/en/",
  },
  {
    title: "Dinner at Glass Terrace",
    type: ItineraryType.Food,
    fixedStart: 2145,
    recommendedDuration: 120,
    attendees: [PersonType.Taylor, PersonType.Saskia, PersonType.Kushla],
    link: "https://maps.app.goo.gl/GgZ8oRG5WXcUxAtd7",
  },
  {
    title: "Sleep",
    type: ItineraryType.Sleep,
    recommendedDuration: 60 * 10,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
  },
  {
    title: "Travel to Cascais",
    type: ItineraryType.Bus,
    fixedStart: 900,
    fixedDuration: 90,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "https://maps.app.goo.gl/1rT7sb7zG3VqcYcv5",
  },
  {
    title: "Rest at hotel",
    type: ItineraryType.Activity,
    recommendedDuration: 30,
    attendees: [PersonType.Chase, PersonType.Lien],
    link: "https://www.vilabicuda.com/en/",
  },
  {
    title: "Walk to Carmo",
    type: ItineraryType.Walk,
    fixedDuration: 20,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
    link: "https://maps.app.goo.gl/1rT7sb7zG3VqcYcv5",
  },
  {
    title: "Brunch at Carmo",
    type: ItineraryType.Food,
    fixedStart: 1130,
    recommendedDuration: 90,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
    link: "https://maps.app.goo.gl/1rT7sb7zG3VqcYcv5",
  },
  {
    title: "Explore Cascais",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 3,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
    link: "https://www.tripadvisor.co.uk/Attractions-g189154-Activities-c47-t76-Cascais_Lisbon_District_Central_Portugal.html",
  },
  {
    title: "Surf Lessons with Taylor",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 4,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
    ],
  },
  {
    title: "Relax on beach",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 4,
    attendees: [PersonType.Kushla],
  },
  {
    title: "Rest at hotel",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
    link: "https://www.vilabicuda.com/en/",
  },
  {
    title: "Dinner at Baía do Peixe",
    type: ItineraryType.Food,
    fixedStart: 1930,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
    link: "https://maps.app.goo.gl/p3CZ1LUdj333jJsP8",
  },
  {
    title: "Sleep",
    type: ItineraryType.Sleep,
    recommendedDuration: 60 * 10,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
  },
  {
    title: "Drive to Euphria",
    type: ItineraryType.Drive,
    fixedDuration: 15,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
    link: "https://maps.app.goo.gl/FrXpwE1nBP5tMhuMA",
  },
  {
    title: "Breakfast at Euphoria",
    type: ItineraryType.Food,
    fixedStart: 930,
    recommendedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
    link: "https://maps.app.goo.gl/FrXpwE1nBP5tMhuMA",
  },
  {
    title: "9 holes of golf",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 3,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
    link: "https://www.quintadamarinha.com/en/menu/golf/golf-courses-cascais-portugal.aspx",
  },
  {
    title: "Lunch at A Nova Estrela",
    type: ItineraryType.Food,
    recommendedDuration: 60 * 1.5,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
    link: "https://maps.app.goo.gl/SCz2fdzvCQCFL7s99",
  },
  {
    title: "Relax on Praia da Conceição beach",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 3,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Saskia,
      PersonType.Kushla,
    ],
    link: "https://maps.app.goo.gl/Qa2vDMXWYzoptvYc7",
  },
  {
    title: "Drive to Lisbon Airport",
    type: ItineraryType.Drive,
    fixedDuration: 60,
    attendees: [PersonType.Saskia],
    link: "https://maps.app.goo.gl/Fk6zJrUXC8brmD8m6",
  },
  {
    title: "Drop keys at rental car office",
    type: ItineraryType.Drive,
    fixedDuration: 15,
    attendees: [PersonType.Saskia],
    link: "https://maps.app.goo.gl/Fk6zJrUXC8brmD8m6",
  },
  {
    title: "Check in at Lisbon Airport",
    type: ItineraryType.Flight,
    fixedDuration: 120,
    attendees: [PersonType.Saskia],
  },
  {
    title: "Flight to London",
    type: ItineraryType.Flight,
    fixedStart: 2015,
    fixedDuration: 2 * 60 + 50,
    attendees: [PersonType.Saskia],
  },
  {
    title: "Rest at hotel",
    type: ItineraryType.Activity,
    fixedStart: 1700,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
    ],
    link: "https://www.vilabicuda.com/en/",
  },
  {
    title: "Dinner at Mar do Inferno",
    type: ItineraryType.Food,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
    ],
    link: "https://maps.app.goo.gl/gkeknupWhoWBDKid9",
  },
  {
    title: "Flight to Lisbon",
    type: ItineraryType.Flight,
    fixedStart: 1900,
    fixedDuration: 2 * 60 + 50,
    attendees: [PersonType.Patrick],
  },
  {
    title: "Pick up keys from rental car office",
    type: ItineraryType.Drive,
    fixedDuration: 15,
    attendees: [PersonType.Patrick],
  },
  {
    title: "Drive to Cascais",
    type: ItineraryType.Drive,
    fixedDuration: 60,
    attendees: [PersonType.Patrick],
    link: "https://maps.app.goo.gl/1rT7sb7zG3VqcYcv5",
  },
  {
    title: "Sleep",
    type: ItineraryType.Sleep,
    recommendedDuration: 60 * 10,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Breakfast at LOCAL",
    type: ItineraryType.Food,
    fixedStart: 1000,
    recommendedDuration: 90,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/GTsR13jNumcgCyB37",
  },
  {
    title: "Drive to Sintra",
    type: ItineraryType.Drive,
    fixedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/3ucA2FE8nm3YkNXb6",
  },
  {
    title: "Explore Palace of Pena",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 3,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://www.parquesdesintra.pt/en/parks-monuments/park-and-national-palace-of-pena/",
  },
  {
    title: "Lunch at Casa das Minas",
    type: ItineraryType.Food,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/rV18mNjGchBM78co6",
  },
  {
    title: "Explore Sintra Town",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://www.tripadvisor.co.uk/Attractions-g189164-Activities-Sintra_Sintra_Municipality_Lisbon_District_Central_Portugal.html",
  },
  {
    title: "Drive back to hotel",
    type: ItineraryType.Drive,
    fixedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/1rT7sb7zG3VqcYcv5",
  },
  {
    title: "Rest at hotel",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://www.vilabicuda.com/en/",
  },
  {
    title: "Dinner at Spi",
    type: ItineraryType.Food,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/GjsLHU8C1eJHY6adA",
  },
  {
    title: "Sleep",
    type: ItineraryType.Sleep,
    recommendedDuration: 60 * 10,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Check out of hotel",
    type: ItineraryType.CheckOut,
    fixedStart: 900,
    fixedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Drive to Nazaré",
    type: ItineraryType.Drive,
    fixedDuration: 120,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/F5US2tCVkuYumhgq6",
  },
  {
    title: "Lunch at Pangeia",
    type: ItineraryType.Food,
    recommendedDuration: 60 * 1.5,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/F5US2tCVkuYumhgq6",
  },
  {
    title: "Surf Nazaré",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 3,
    attendees: [PersonType.Chase, PersonType.Taylor],
    link: "https://maps.app.goo.gl/N8s7m1hax58C5bPh9",
  },
  {
    title: "Explore Nazaré",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 2,
    attendees: [PersonType.Lien, PersonType.Kushla, PersonType.Patrick],
    link: "https://maps.app.goo.gl/XeknMfS6NeDiPH77A",
  },
  {
    title: "Check out Forte de Sao Miguel",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 1,
    attendees: [PersonType.Lien, PersonType.Kushla, PersonType.Patrick],
    link: "https://maps.app.goo.gl/iV2kVQ7aAsPFfb4g9",
  },
  {
    title: "Drive to Aviero",
    type: ItineraryType.Drive,
    fixedDuration: 120,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/Eb862NSPYREYFodm8",
  },
  {
    title: "Check out Aveiro old town",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 1.5,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/Eb862NSPYREYFodm8",
  },
  {
    title: "Eat Ovos Moles",
    type: ItineraryType.Activity,
    recommendedDuration: 30,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/ZRyJf9VZE2qrEdFHA",
  },
  {
    title: "Drive to Porto",
    type: ItineraryType.Drive,
    fixedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/uPpvMB5KSAzTnNdP6",
  },
  {
    title: "Check in to hotel",
    type: ItineraryType.CheckIn,
    fixedDuration: 30,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/uPpvMB5KSAzTnNdP6",
  },
  {
    title: "Rest at hotel",
    type: ItineraryType.Activity,
    recommendedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/uPpvMB5KSAzTnNdP6",
  },
  {
    title: "Walk to Rio's Tapas & Bar",
    type: ItineraryType.Walk,
    fixedDuration: 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/MotYjgpo9G6ZpuRc9",
  },
  {
    title: "Dinner at Rio's Tapas & Bar",
    type: ItineraryType.Food,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/MotYjgpo9G6ZpuRc9",
  },
  {
    title: "Walk to hotel",
    type: ItineraryType.Walk,
    fixedDuration: 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/uPpvMB5KSAzTnNdP6",
  },
  {
    title: "Sleep",
    type: ItineraryType.Sleep,
    recommendedDuration: 60 * 10,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Walk to Majestic Café",
    type: ItineraryType.Walk,
    fixedDuration: 8,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/kAgG3X7cfXXFcevw7",
  },
  {
    title: "Coffee at Majestic Café",
    type: ItineraryType.Food,
    fixedStart: 1000,
    recommendedDuration: 30,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/kAgG3X7cfXXFcevw7",
  },
  {
    title: "Walk to Mercado do Bolhão",
    type: ItineraryType.Walk,
    fixedDuration: 3,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/K9V2M7DvdsyzNgQ2A",
  },
  {
    title: "Explore Mercado do Bolhão",
    type: ItineraryType.Activity,
    recommendedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/K9V2M7DvdsyzNgQ2A",
  },
  {
    title: "Walk to McDonald's",
    type: ItineraryType.Walk,
    fixedDuration: 6,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/xsbpHSxhfbsArEdh9",
  },
  {
    title: "Lunch at McDonald's",
    type: ItineraryType.Food,
    recommendedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/xsbpHSxhfbsArEdh9",
  },
  {
    title: "Segway Tour",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 2.5,
    attendees: [PersonType.Lien, PersonType.Taylor, PersonType.Kushla],
    link: "https://www.tripadvisor.co.uk/AttractionProductReview-g189180-d13797779-Porto_2_Hour_City_Highlights_Segway_Tour_Guided_Experience-Porto_Porto_District_No.html",
  },
  {
    title: "Visit Oporto Magic",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 2.5,
    attendees: [PersonType.Patrick, PersonType.Chase],
    link: "https://maps.app.goo.gl/mJgFNd2MTsqTMGAA6",
  },
  {
    title: "River Cruise",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 2.5,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://www.tripadvisor.co.uk/AttractionProductReview-g189180-d11461214-Porto_Six_Bridges_Panoramic_Cruise_on_the_Douro_River-Porto_Porto_District_Norther.html",
  },
  {
    title: "Rest at hotel",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/uPpvMB5KSAzTnNdP6",
  },
  {
    title: "Dinner at Brasão Aliados",
    type: ItineraryType.Food,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/1KyU4qJJMmN22nYJ7",
  },
  {
    title: "Beer at Cervejaria Nortada",
    type: ItineraryType.Activity,
    recommendedDuration: 45,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/3d2qB7zhbwhp6R5D7",
  },
  {
    title: "Beer at Armazém da Cerveja",
    type: ItineraryType.Activity,
    recommendedDuration: 45,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/WiM1n2iwYt3fgjuVA",
  },
  {
    title: "Sleep",
    type: ItineraryType.Sleep,
    recommendedDuration: 60 * 10,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Walk to Honest Greens",
    type: ItineraryType.Walk,
    fixedDuration: 9,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/RNmss9BRmJREP4zN8",
  },
  {
    title: "Brunch at Honest Greens",
    type: ItineraryType.Food,
    fixedStart: 1100,
    recommendedDuration: 90,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/RNmss9BRmJREP4zN8",
  },
  {
    title: "Drive to Douro Valley",
    type: ItineraryType.Drive,
    fixedDuration: 120,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/394PDVWC54e7uYVL7",
  },
  {
    title: "Check in to hotel",
    type: ItineraryType.CheckIn,
    fixedDuration: 30,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/394PDVWC54e7uYVL7",
  },
  {
    title: "Rest at hotel",
    type: ItineraryType.Activity,
    recommendedDuration: 120,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/394PDVWC54e7uYVL7",
  },
  {
    title: "Dinner at Veladouro",
    type: ItineraryType.Food,
    recommendedDuration: 60 * 1.5,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/UvLe2nXNooBQb3bk6",
  },
  {
    title: "Sleep",
    type: ItineraryType.Sleep,
    recommendedDuration: 60 * 10,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Breakfast at hotel",
    type: ItineraryType.Food,
    fixedStart: 1000,
    recommendedDuration: 90,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Relax at hotel",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 4,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Taxi to Regua",
    type: ItineraryType.Drive,
    fixedDuration: 45,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/ZmtZ5hJnNGtUYCE97",
  },
  {
    title: "Regua to Tua Historical Train Ride",
    type: ItineraryType.Train,
    fixedStart: 1530,
    fixedDuration: 3 * 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://www.cp.pt/passageiros/en/how-to-travel/For-leisure/Nature-and-Culture/douro-historical-train",
  },
  {
    title: "Taxi to Cozinha da Clara",
    type: ItineraryType.Drive,
    fixedDuration: 30,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/Ytsh8QtHXNPor49V7",
  },
  {
    title: "Dinner at Cozinha da Clara",
    type: ItineraryType.Food,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/Ytsh8QtHXNPor49V7",
  },
  {
    title: "Taxi to hotel",
    type: ItineraryType.Drive,
    fixedDuration: 15,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Sleep",
    type: ItineraryType.Sleep,
    recommendedDuration: 60 * 10,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Breakfast at hotel",
    type: ItineraryType.Food,
    fixedStart: 1000,
    recommendedDuration: 90,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Drive to Dock",
    type: ItineraryType.Drive,
    fixedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Douro River Cruise",
    type: ItineraryType.Activity,
    recommendedDuration: 60 * 5,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Drive to Hotel",
    type: ItineraryType.Drive,
    fixedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Rest at hotel",
    type: ItineraryType.Activity,
    recommendedDuration: 30,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Drive to Quinta de La Rosa",
    type: ItineraryType.Drive,
    fixedDuration: 15,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/58m6Krc6W4pixUP87",
  },
  {
    title: "Dinner at Quinta de La Rosa",
    type: ItineraryType.Food,
    recommendedDuration: 60 * 2,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/58m6Krc6W4pixUP87",
  },
  {
    title: "Drive to hotel",
    type: ItineraryType.Drive,
    fixedDuration: 15,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Sleep",
    type: ItineraryType.Sleep,
    recommendedDuration: 60 * 10,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Breakfast at hotel",
    type: ItineraryType.Food,
    fixedStart: 1000,
    recommendedDuration: 90,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Check out of hotel",
    type: ItineraryType.CheckOut,
    fixedDuration: 60,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Drive to Porto Airport",
    type: ItineraryType.Drive,
    fixedDuration: 90,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
    link: "https://maps.app.goo.gl/6GSLgN2qfbMufmLF7",
  },
  {
    title: "Check into flight",
    type: ItineraryType.Flight,
    fixedDuration: 120,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
  {
    title: "Fly to London",
    type: ItineraryType.Flight,
    fixedStart: 1550,
    fixedDuration: 2 * 60 + 50,
    attendees: [
      PersonType.Chase,
      PersonType.Lien,
      PersonType.Taylor,
      PersonType.Kushla,
      PersonType.Patrick,
    ],
  },
];

export default ITINERARY;
